import { debounce } from 'lodash-es';

class Template {
  constructor() {
    this.wrap = $('.site-content');
    this.elements = {
      main: this.wrap.find('[data-main]'),
      sidebar: this.wrap.find('[data-sidebar]'),
    };

    this.initEvents();
  }

  initEvents() {
    $(document).on('bvm_template_init_sticky_sidebar', () => {
      this.initStickySidebar();
    });

    $(document).on('bvm_template_set_as_empty', () => {
      this.setAsEmpty();
    });

    $(document).on('bvm_template_set_as_not_empty', () => {
      this.setAsNotEmpty();
    });

    $(document).trigger('bvm_template_init_sticky_sidebar');
  }

  initStickySidebar() {
    if (! this.hasStickySidebar()) {
      return;
    }

    if (this.sidebarHasAds()) {
      const interval = setInterval(() => {
        if (window.googletag && window.googletag.apiReady) {
          window.googletag.pubads().addEventListener('slotOnload',  debounce(() => {
            this.setStickySidebar();
          }, 500, { 'leading': true, 'maxWait' : 500 }));

          clearInterval(interval);
        }
      }, 100);
    }
  }

  setStickySidebar() {
    if (! this.hasStickySidebar()) {
      return;
    }

    let height = 0;

    this.elements.sidebar.children().each((i, child) => {
      height += $(child).outerHeight(true);
    });

    this.elements.sidebar.css('top', (height - window.innerHeight) * -1 + 'px');
  }

  hasSidebar() {
    if (! this.wrap.hasClass('-sidebar')) {
      return false;
    }

    if (this.elements.sidebar.length !== 1) {
      return false;
    }

    return true;
  }

  hasStickySidebar() {
    return this.hasSidebar() && this.wrap.hasClass('-sidebar-sticky');
  }

  sidebarHasAds() {
    return this.hasSidebar() && this.elements.sidebar.find('.block-a_d').length > 0;
  }

  setAsEmpty() {
    this.wrap.addClass('-empty');
  }

  setAsNotEmpty() {
    this.wrap.removeClass('-empty');
  }
}

export default Template;
